import BaseSignature from './BaseSignature'

/* services  */
import CargaService from "@/services/CargaService"
import BryService from '@/services/Assinaturas/BryService'

class CargaSignature extends BaseSignature {
  async carga (registro_id) {
    /**
     * Iniciamos a assinatura da carga enviando o certificado e o registro id
     * que pode ser unico ou um array de ids
     */
    const start = await CargaService.gerarXml({
      certificate: this.certificadoSelecionado.certificateData,
      registro_id: registro_id
    })

    // Se não tiver documentos não deixamos continuar e mostramos msg de erro
    if (!start.documents || !start.documents.length) {
      if (start.errors) return start.errors
      throw new Error('Nenhum documento disponível para assinatura.')
    }

    // Percorremos o assinaturasInicializadas para formatar cada dado e jogar num array de assinaturas
    const signaturesObj = start.init.assinaturasInicializadas.map(({ messageDigest, nonce }) => {
      return BryService.prepareContentForSignature(messageDigest, nonce)
    })

    // Assinamos todos
    const signatures = await BryService.signBase64Content(this.certificadoSelecionado.certId, signaturesObj)

    /**
    * Fazemos esse map para pegar a signatureValue de cada documento,
    * independente se for lote ou individual
    */
    const signatureValues = signatures.assinaturas.map((signature) => {
      return signature.hashes[0]
    })

    // Montamos os documentos para envir na parte final da assinatura apenas com o necessario
    const documents = start.documents.map((document, index) => {
      return {
        file_name: document.file_name,
        document_id: document.document_id,
        document_original: document.document,
        signatureValue: signatureValues[index],
        signedAttributes: signaturesObj[index].hashes[0]
      }
    })

    /**
     * Enviamos a quantidade de erros da parte inicial da assinatura para o back
     * somar com os erros da parte final
     */
    const end = await CargaService.enviarXmlAssinado({
      bryNonce: start.init.nonce,
      certificate: this.certificadoSelecionado.certificateData,
      documents,
      qtd_erros: start.errors.length,
      signatures
    })

    // Se tiver algum dos erros, os justamos e enviamos como response
    if (start.errors || end.errors) {
      const startErrors =  Array.isArray(start.errors) ? start.errors : [start.errors]
      const endErrors =  Array.isArray(end.errors) ? end.errors : [end.errors]
      const errors = [...startErrors, ...endErrors]

      if (errors || errors.length) {
        return { end, errors }
      }
    } else {
      return end
    }
  }
}

export default CargaSignature
